<template>
  <div>
    <v-toolbar flat dense>
      <v-toolbar-title class="text-h6">{{ typeName }}</v-toolbar-title>
    </v-toolbar>
    <v-tabs v-model="activeTab" color="primary accent-4">
      <v-tab>Items</v-tab>
      <v-tab>Categories</v-tab>
      <v-tab>Sorting</v-tab>

      <v-tab-item>
        <cms-items :type-slug="typeSlug" />
      </v-tab-item>
      <v-tab-item>
        <cms-categories :type-slug="typeSlug" />
      </v-tab-item>
      <v-tab-item>
        <cms-sorting :type-slug="typeSlug" />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
const TABS = ['items', 'categories', 'sorting']

export default {
  components: {
    CmsItems: () => import('@/components/cms/items/Items'),
    CmsCategories: () => import('@/components/cms/categories/CmsCategories'),
    CmsSorting: () => import('@/components/cms/sorting/CmsSorting'),
  },
  computed: {
    typeSlug() {
      return this.$route.params.typeSlug || null
    },
    typeName() {
      const t = this.$store.state.cms.main.types.find(x => x.slug === this.typeSlug)
      return t ? t.name : this.typeSlug
    },
    activeTab: {
      get() {
        const i = TABS.indexOf(this.$route.params.tab)
        return i >= 0 ? i : 0
      },
      set(index) {
        const tab = TABS[index] || TABS[0]
        if (tab !== this.$route.params.tab) {
          this.$router.replace({ name: 'CMSType', params: { typeSlug: this.typeSlug, tab } }).catch(() => {})
        }
      },
    },
  },
}
</script>